/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Component imports.
 */
import { CommonSuggestionComponent } from './common-suggestion.component';
import { DetailSuggestionCardComponent } from '../web-feed-detail/detail-suggestion-card/detail-suggestion-card.component';
import { ForwordFlowsSuggestionCardComponent } from './forword-flows-suggestion-card/forword-flows-suggestion-card.component';

/**
 * Module imports.
 */
import { SuggestionDrugSampleCardModule } from '../../drug-sample/suggestion-drug-sample-card/suggestion-drug-sample-card.module';



@NgModule({
  declarations: [
    CommonSuggestionComponent,
    DetailSuggestionCardComponent,
    ForwordFlowsSuggestionCardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SuggestionDrugSampleCardModule
  ],
  exports: [
    CommonSuggestionComponent,
    ForwordFlowsSuggestionCardComponent
  ]
})
export class CommonSuggestionModule { }
